import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateDirective } from '@ngx-translate/core';
import { RouterBaseService } from '@tdwb/core';
import { SelectableInputPanelComponent } from '../../../components/selectable-input-panel/selectable-input-panel.component';
import { FormRowComponent } from '../../../components/form/row/form-row.component';
import { FormComponent } from '../../../components/form/form.component';
import { RadioGroupComponent } from '../../../components/radio/radio-group.component';
import { InputStatusIndicatorDirective } from '../../../components/form/input-status/input-status-indicator.directive';
import { InputDirective } from '../../../components/input/input.directive';
import { InputGroupFieldComponent } from '../../../components/form/input-group/input-group-field.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { NotificationComponent } from '../../../components/notification/notification.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { DividerComponent } from '../../../components/panel/divider.component';
import { RadioComponent } from '../../../components/radio/radio.component';
import { InputGroupComponent } from '../../../components/form/input-group/input-group.component';
import { InputGroupLabelComponent } from '../../../components/form/input-group/input-group-label.component';
import { W8BenFormErrorComponent } from '../w8ben-form-error/w8ben-form-error.component';

import { W8BenFormTooltipComponent } from '../w8ben-form-tooltip/w8ben-form-tooltip.component';

import { W8BenFormService } from '../w8ben-form.service';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { W8BenModalName } from '../w8ben-form.domain';

@Component({
  selector: 'td-wb-w8ben-tax-residency-benefits',
  templateUrl: 'w8ben-form-tax-residency-benefits.component.html',
  styleUrls: ['w8ben-form-tax-residency-benefits.component.scss'],
  imports: [
    NotificationComponent,
    FormComponent,
    FormRowComponent,
    InputGroupComponent,
    InputGroupLabelComponent,
    InputGroupFieldComponent,
    FormsModule,
    TranslateDirective,
    RadioGroupComponent,
    SelectableInputPanelComponent,
    RadioComponent,
    DividerComponent,
    ButtonComponent,
    HrefDirective,
    InputGroupFieldComponent,
    InputDirective,
    W8BenFormTooltipComponent,
    InputStatusIndicatorDirective,
    W8BenFormErrorComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class W8BenFormTaxResidencyBenefitsComponent implements OnInit {
  @Input() hasUpdates: boolean = false;

  protected taxResidency: string = 'Canada';
  protected submitError: boolean = false;
  protected specialRatesConditions: boolean | null = null;

  constructor(private routerService: RouterBaseService,
              private w8benFormService: W8BenFormService,
              private w8BenFormAnalyticsService: W8BenFormAnalyticsService,
              private changeDetectionRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.w8BenFormAnalyticsService.setTaggingData(W8BenModalName.TAX_RESIDENCY, 'n/a');
    if (!this.hasUpdates) {
      this.taxResidency = this.w8benFormService.getTaxResidency();
    }
  }

  protected getModalId(): string {
    return this.w8BenFormAnalyticsService.getModalId();
  }

  onClickContinue(): void {
    if (this.specialRatesConditions) {
      this.routerService.go('modal.w8ben.special_tax_benefits', { hasUpdates: this.hasUpdates });
    } else if (this.specialRatesConditions === false) {
      if (this.hasUpdates) {
        this.w8benFormService.updateProfile(this.hasUpdates)?.subscribe({
          next: () => {
            this.routerService.go('modal.w8ben.review', { hasUpdates: this.hasUpdates });
          },
          error: (): void => {
            this.submitError = true;
            this.changeDetectionRef.markForCheck();
          },
          complete(): void {
          }
        });
      } else {
        this.routerService.go('modal.w8ben.us_tin', { hasUpdates: this.hasUpdates });
      }
    }
  }
}

